module.exports = __webpack_public_path__ + "img/team-icon.5564e441.svg";